var map = {
	"./api.service.js": 1345,
	"./authentication.service.js": 1346,
	"./client-application.service.js": 1347,
	"./dialog.service.js": 1348,
	"./export.service.js": 1350,
	"./hacky/selected-book-list-service.js": 1351,
	"./history.service.js": 1352,
	"./http.service.js": 1353,
	"./models/actions.service.js": 1354,
	"./models/application.service.js": 1355,
	"./models/book.service.js": 1356,
	"./models/cloud.service.js": 1357,
	"./models/institution.service.js": 1358,
	"./models/reseller.service.js": 1359,
	"./models/transaction.service.js": 1360,
	"./models/user.service.js": 1361,
	"./notification.service.js": 1362,
	"./role-handler.service.js": 1363,
	"./route-handler.service.js": 1364,
	"./route.service.js": 1365,
	"./ui.service.js": 1366,
	"./user-actions.service.js": 1367,
	"./utilities.service.js": 1368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1344;